"use strict";

exports.__esModule = true;
exports["default"] = exports.ProductTitle = exports.ProductInfo = exports.ProductImage = exports.DocIcon = exports.DocContainer = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _downloadLink = _interopRequireWildcard(require("./download-link"));

var _rawHtml = _interopRequireDefault(require("../../primitives/raw-html"));

var _elements = require("../../components/glyphs/elements");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DocIcon = (0, _styledComponents["default"])(_elements.DocumentsGenericDocument).withConfig({
  displayName: "featured-document-item__DocIcon",
  componentId: "sc-us7vua-0"
})(["margin-right:8px;width:18px;height:18px;vertical-align:text-bottom;margin-bottom:2px;"]);
exports.DocIcon = DocIcon;
var DocContainer = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "featured-document-item__DocContainer",
  componentId: "sc-us7vua-1"
})(["display:grid;column-gap:0;row-gap:0;text-decoration:none;grid-template-columns:auto 1fr;&:hover{border-color:#fff;box-shadow:2px 4px 20px 0 rgba(0,0,0,0.1);border-radius:10px;}"]);
exports.DocContainer = DocContainer;
var ProductImage = (0, _styledComponents["default"])(_primitives["default"].Image).withConfig({
  displayName: "featured-document-item__ProductImage",
  componentId: "sc-us7vua-2"
})(["grid-column:1;grid-row:1;object-fit:cover;border-radius:8px 0 0 8px;@media (max-width:549px){border-radius:8px 8px 0 0;}"]);
exports.ProductImage = ProductImage;
var ProductTitle = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "featured-document-item__ProductTitle",
  componentId: "sc-us7vua-3"
})([""]);
exports.ProductTitle = ProductTitle;
var ProductInfo = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "featured-document-item__ProductInfo",
  componentId: "sc-us7vua-4"
})(["line-height:24px;grid-column:2;grid-row:1;@media (max-width:549px){grid-row:2;grid-column:1;}"]);
exports.ProductInfo = ProductInfo;
var FeaturedDocItemBody = (0, _styledComponents["default"])(function (props) {
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, _extends({
    fontSize: [3],
    letterSpacing: "0.5px",
    lineHeight: 1.5,
    mb: 1
  }, props));
}).withConfig({
  displayName: "featured-document-item__FeaturedDocItemBody",
  componentId: "sc-us7vua-5"
})(["color:", ";"], function (props) {
  return (0, _styles.colors)("body-grey", props);
});
var OverflowBox = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "featured-document-item__OverflowBox",
  componentId: "sc-us7vua-6"
})(["overflow-x:auto;overflow-y:hidden;"]);
var propTypes = {
  /** The main content of the document item */
  description: _propTypes.string,

  /** An array of download option objects, optionOnClick overrides downloadAction */
  downloadOption: (0, _propTypes.shape)(_downloadLink.downloadOptionPropType),

  /** Image on the left of the content */
  image: _propTypes.string.isRequired,

  /** Title for the document */
  title: _propTypes.string.isRequired,

  /** Url for when a document item is a link */
  url: _propTypes.string
};
var defaultProps = {
  description: ""
};

var FeaturedDocItem = function FeaturedDocItem(_ref) {
  var description = _ref.description,
      downloadOption = _ref.downloadOption,
      image = _ref.image,
      title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement(DocContainer, {
    borderRadius: 8,
    boxShadow: [2, 1],
    forwardedAs: "section",
    mt: [3]
  }, image && /*#__PURE__*/_react["default"].createElement(ProductImage, {
    height: ["224px", 1],
    src: image,
    width: [1, "303px", "258px", "275px", "331px"]
  }), /*#__PURE__*/_react["default"].createElement(ProductInfo, {
    pl: [2, "38px", "37px", "39px", "47px"],
    pr: [2, 4],
    py: [3, 4]
  }, /*#__PURE__*/_react["default"].createElement(ProductTitle, {
    color: "gray-dark",
    fontSize: [4],
    fontWeight: 2,
    lineHeight: 2,
    pb: [1],
    tag: "h1"
  }, /*#__PURE__*/_react["default"].createElement(DocIcon, null), title), description && /*#__PURE__*/_react["default"].createElement(_rawHtml["default"], {
    html: description,
    tag: FeaturedDocItemBody
  }), /*#__PURE__*/_react["default"].createElement(OverflowBox, {
    mt: 2
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, null, /*#__PURE__*/_react["default"].createElement(_downloadLink["default"], downloadOption)))));
};

FeaturedDocItem.propTypes = propTypes;
FeaturedDocItem.defaultProps = defaultProps;
var _default = FeaturedDocItem;
exports["default"] = _default;